module.exports = __webpack_public_path__ + "static/media/profile-bg.f1447756.png";